import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Box from "@mui/material/Box";

import Actions from "../Certificate/Actions";

import TableComponent from "../TableComponent";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const CourseList = ({ courses, showDescriptions }) => {
  const { t } = useTranslation();
  const only = useQuery().get("only");
  const [filtered, setFiltered] = useState(!!only?.length);
  if (filtered && only?.length) {
    const m = only.split(",").reduce((m, it) => ({ ...m, [+it]: true }), {});
    courses = courses.filter((c) => m[c.id]);
  }

  const header = [
    { title: t("course_list.id"), style: { width: "5%" } },
    { title: t("course_list.name"), style: { width: "30%" } },
    { title: t("course_list.description"), style: { width: "35%" } },
    { title: t("course_list.type"), style: { width: "35%" } },
    { title: t("course_list.price"), style: { width: "15%" } },
    { title: t("course_list.actions"), style: { width: "15%" } },
  ];
  if (!showDescriptions) {
    header.splice(2, 1);
    header[1].style.width = "65%";
  }
  return (
    <>
      {filtered && (
        <Box style={{ paddingBottom: 15 }}>
          {t("course_list.showing_filtered_courses")}{" "}
          <button onClick={() => setFiltered(false)}>{t("course_list.show_all")}</button>
        </Box>
      )}
      <TableComponent
        pagination
        pageSize={25}
        items={courses}
        search={["id", "name"]}
        header={header}
        renderChildren={(course) => (
          <TableRow key={course.id}>
            <TableCell>{course.id}</TableCell>
            <TableCell>{course.name}</TableCell>
            {showDescriptions && <TableCell>{course.description}</TableCell>}
            <TableCell>{course.type}</TableCell>
            <TableCell>{+course.price ? course.price : t("course_list.free")}</TableCell>
            <TableCell style={{ width: "5%" }}>
              <Actions courseCertificate={course} />
            </TableCell>
          </TableRow>
        )}
      />
    </>
  );
};

export default CourseList;
